// extracted by mini-css-extract-plugin
export default {"cls1":"X3wIZF5cfvxEeZ5aF7WN","cls2":"ISiyv0LphNu2cxlvUmQ8 X3wIZF5cfvxEeZ5aF7WN"};